import styled from 'styled-components';

export default styled.div`
    min-width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: var(--surface-level-1-bg);
`;
